import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/salesData';
interface TestimonialCardProps {
  testimonial: Testimonial;
  showLocation?: boolean;
}
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-214" data-mp="2kfx3vwi4amjo">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[var(--rose)] text-[var(--rose)]" aria-hidden="true" data-id="element-215" data-mp="2p99g175m10vj" data-mpi={i} />)}
    </div>;
}
export function TestimonialCard({
  testimonial,
  showLocation = true
}: TestimonialCardProps) {
  return <figure className="flex h-full flex-col rounded-2xl border border-[var(--line)] bg-[var(--surface)] p-6 transition-colors duration-200 ease-out hover:border-[var(--rose)]/50" data-id="element-216" data-mp="344pbnglu94u1">
      <div className="mb-4 flex items-center gap-3" data-id="element-217" data-mp="19rg1dmlgxfaq">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[var(--slate)]/25 text-sm font-bold text-[var(--text)]" aria-hidden="true" data-id="element-218" data-mp="19sr2tfrfyayo">
          {testimonial.initials}
        </span>
        <div data-id="element-219" data-mp="d1kufnr2r436">
          <figcaption className="font-semibold text-[var(--text)]" data-id="element-220" data-mp="d1uobmf8pve5">
            {testimonial.name}
            {showLocation && <span className="font-normal text-[var(--text-soft)]" data-id="element-221" data-mp="83ayhaxizzgi">
                {' '}
                · {testimonial.location}
              </span>}
          </figcaption>
          <Stars data-id="element-222" data-mp="10r6ra4jz5780" />
        </div>
      </div>
      <blockquote className="text-[var(--text)]/80" data-id="element-223" data-mp="vsm1kz2cm5xt">
        “{testimonial.quote}”
      </blockquote>
    </figure>;
}